module.exports = __webpack_public_path__ + "static/media/texture-5.a30eaa92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/texture-5.jpg
// module id = 121
// module chunks = 0